import { AdaptiveMenuItem } from "@/lib/components/ui/adaptive-menu/adaptive-menu";
import Pin from "@/lib/components/ui/icons/pin";
import PinOff from "@/lib/components/ui/icons/pin-off";
import { useTranslation } from "react-i18next";
import { usePinnedThreadIds, useToggleThreadPin } from "../../threads.pin";
import type { Thread } from "../../threads.utils";

export function ThreadsListPin({
  thread,
  assistantId,
}: {
  thread: Thread;
  assistantId: string;
}) {
  const { t } = useTranslation();

  const pinnedIds = usePinnedThreadIds(assistantId);
  const togglePin = useToggleThreadPin(assistantId);
  const pinned = thread.id ? pinnedIds.has(thread.id) : false;

  return (
    <AdaptiveMenuItem
      onClick={() => {
        if (thread.id) {
          togglePin(thread.id);
        }
      }}
    >
      {pinned ? <PinOff /> : <Pin />}
      {pinned ? t("threads_action_unpin") : t("threads_action_pin")}
    </AdaptiveMenuItem>
  );
}
